import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap'

import { FaIcon } from '../../../../shared/components'
const { Addon } = InputGroup

const NameFilter = ({ onChange, leagueName, loadingFilters }) => {
  const inputRef = useRef(null)
  const searchText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.league_name.search_sim_golf'))

  const handleChange = (event) => {
    onChange('leagueName', event.target.value)
  }

  return (
    <FormGroup className='filter btsp_filter filter_league_name_container_sim_golf' >
      <InputGroup>
        <Addon className='add_on_shearch_sim_golf'>
          { loadingFilters
            ? <FaIcon icon='spinner' spin={ true } />
            : <FaIcon icon='search' />
          }
        </Addon>
        <FormControl
          type='text'
          value={ leagueName }
          placeholder={ searchText }
          onChange={ handleChange }
          inputRef={ ref => { inputRef.current = ref } }
        />
      </InputGroup>
    </FormGroup>
  )
}

NameFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  leagueName: PropTypes.string,
  loadingFilters: PropTypes.bool,
}

export default NameFilter